module.exports = __webpack_public_path__ + "static/linkcopy-08431f0c7053f6937358c0a3dc64d606.png";